"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "role-timeline-row" };
const _hoisted_2 = { class: "role-timeline-row-content" };
const _hoisted_3 = { class: "role-timeline-row-track" };
const RoleTimeBlock_vue_1 = __importDefault(require("./RoleTimeBlock.vue"));
const roleTimeLayout_1 = require("../roleTimeLayout");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleTimeRow',
    props: {
        role: {},
        timeRange: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createCommentVNode)(" role-Timeline "),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createCommentVNode)(" Role Block "),
                        (0, vue_2.createVNode)(RoleTimeBlock_vue_1.default, {
                            role: __props.role,
                            "time-range": __props.timeRange
                        }, null, 8 /* PROPS */, ["role", "time-range"]),
                        (0, vue_2.createCommentVNode)(" Hour grid "),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.timeRange.end - __props.timeRange.start + 1, (hour) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: hour,
                                class: "role-timeline-row-line",
                                style: (0, vue_2.normalizeStyle)({
                                    left: `${(0, vue_2.unref)(roleTimeLayout_1.getRolePosition)(hour - 1 + props.timeRange.start, props.timeRange.start, props.timeRange.end)}%`,
                                })
                            }, null, 4 /* STYLE */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
